<template>
  <div v-if="shouldShowTimeoutWarning" id="modal-overlay">
    <div id="modal-panel">
      <p>{{ $t('common.sessionTimeout.message') }}</p>
      <button id="reload-button" @click="stayLoggedIn">{{ $t('common.sessionTimeout.stayLoggedIn') }} </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'TimeoutWindow',

  computed: {
    ...mapGetters('timer', ['remainingSeconds', 'warningThreshold']),

    shouldShowTimeoutWarning() {
      return this.remainingSeconds > 0 && this.remainingSeconds <= this.warningThreshold;
    },
  },

  methods: {
    ...mapActions('timer', ['initializeTimer', 'stopListener']),

    stayLoggedIn() {
      this.initializeTimer();
    },
  },

  watch: {
    shouldShowTimeoutWarning(newValue) {
      if(newValue) {
        this.stopListener();
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import '@scss';

.stay-logged-in-button {
  padding: 10px 20px;
  margin-top: 10px;
}

.stay-logged-in-button:hover {
  background-color: $color-gray-light;
}
</style>
